import React, { Component } from 'react';
import { connect } from 'react-redux';
import { t1 } from 'translate';
import Loading from 'components/common/loading';
import { withRouter } from 'react-router';
import { getRootUrl } from 'routes/links/common';
import lGet from 'lodash.get';
import Widget from 'components/common/Widget';
import { Link } from 'react-router-dom';
import { getThemeConfig } from 'utils/selectors';
import withUserInfo from 'common/hoc/withUserInfo';
import Icon from 'components/common/Icon';
import menus from '../menu-configs';
import '../stylesheet.scss';

class ProfileDashboardX extends Component {
  render() {
    const { user, userInfo } = this.props;

    if (!user) return <Loading />;

    let listMenuToShow = menus(userInfo);

    if (!listMenuToShow) return null;

    return (
      <div>
        <div className="text-center m-b-10">
          <h1>
            <Icon icon="profile" antIcon /> {t1('manage_profile')}
          </h1>
        </div>
        <div className="container-fluid user-dashboard">
          <div className="flex-container-wrap">
            {listMenuToShow.map(({ href, icon, label }) => (
              <div className="col-sm-4 flex-item ">
                <Widget className="text-center m-10">
                  <Link to={href} className="user-dashboard-link">
                    <div>{icon}</div>
                    <div style={{ 'text-transform': 'uppercase' }}>{label}</div>
                  </Link>
                </Widget>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  loadingStatus:
    state.loading && state.loading.status ? state.loading.status : null,
  rootUrl: getRootUrl(props),
  themeConfig: getThemeConfig(state),
  pathname: lGet(props, 'location.pathname'),
});

export default withRouter(
  connect(mapStateToProps)(withUserInfo(ProfileDashboardX)),
);
